import { useState } from 'react'

import classNames from 'classnames'

import Text, { TextSizes } from '../Text/Text'
import Tooltip from '../Tooltip/Tooltip'

import styles from './AvailabilityIndicator.module.css'

export interface AvailabilityIndicatorProps {
  inventoryPriority?: number
  testID?: string
  showTooltip?: boolean
  isListing?: boolean
}

export default function AvailabilityIndicator({
  inventoryPriority,
  showTooltip = true,
  isListing = false,
  testID,
}: AvailabilityIndicatorProps) {
  if (!inventoryPriority || inventoryPriority <= 0)
    return (
      <Text
        size={TextSizes.bodySml}
        className={classNames(isListing && styles.listingText)}
      >
        N/A
      </Text>
    )

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [showToolTip, setShowToolTip] = useState<boolean>(false)

  return (
    <div className={styles.base} data-testid={testID}>
      <div className={styles.indicator}>
        <div className={styles.dot}></div>
        <Text
          size={TextSizes.bodySml}
          className={classNames(isListing && styles.listingText)}
        >
          Available immediately
        </Text>
        {showTooltip && (
          <Tooltip
            handleClick={() => setShowToolTip(!showToolTip)}
            isActive={showToolTip}
          />
        )}
      </div>
      {showTooltip && (
        <Text
          size={TextSizes.bodySml}
          Tag="p"
          className={classNames(
            styles.toolTipText,
            showToolTip && styles.toolTipTextVisible
          )}
        >
          This artwork is available now through our network of collectors.
        </Text>
      )}
    </div>
  )
}
